//-----------------------------------------------------------------------------
// Copyright 2021-2025 by banbutsu dcp GmbH. Confidential. All rights reserved.
//-----------------------------------------------------------------------------
// Project: platform frontend
// Author:  thomas.driemeyer@banbutsu.com
//
// English translations. The first string in every pair is passed to the
// translate function, looked up here, and replaced with the second string.
//-----------------------------------------------------------------------------

export const translationsEN = new Map<string, string>([
    ["What are you interested in?", "What are you interested in?"],
    ["Design Your Trip", "Design Your Trip"],
    ["Sorry, a server problem", "Sorry, a server problem has occurred"],
    ["Preparing your selection", "Preparing your selection"],
    ["Continue", "Continue"],
    ["Select a package first", "Select a package first"],
    ["Please refresh the page", "Please refresh the page"],
    ["Apply changes", "Apply changes"],
    ["server error package", "Sorry, a server error occured updating your package"],
    ["Please go back and try again", "Please go back and try again"],
    ["error creating booking", "An error occured creating your booking"],
    ["Go Back", "Go Back"],
    ["Your shopping cart", "Your shopping cart"],
    ["final look at your orders", "Have a final look at your orders and provide some final booking data before you proceed to the payment."],
    ["Adult", "Adult"],
    ["Adults", "Adults"],
    ["Total (incl. VAT)", "Total (incl.&nbsp;VAT)"],
    ["map rendering problem", "Sorry, a map rendering problem has occurred"],
    ["Your booking locations", "Your booking locations"],
    ["confirm payment", "confirm payment"],
    ["Sorry error creating booking", "Sorry, an error occured creating your booking"],
    ["Please refresh and try again", "Please refresh and try again"],
    ["error booking confirmation", "An error occurred during your booking confirmation."],
    ["Please try again. We sincerly apologise", "Please try again. We sincerly apologise"],
    ["Back to start page", "Back Home"],
    ["PAYMENT CONFIRMATION", "PAYMENT CONFIRMATION"],
    ["about to pay the following items", "You are about to pay the following items to the listed retail and service partners. Please confirm by activating the switch below."],
    ["Booking", "Booking"],
    ["Confirm the payment and accept the", "Confirm the payment and accept the"],
    ["Terms and Conditions", "Terms and Conditions"],
    ["Add", "Add"],
    ["Remove", "Remove"],
    ["Reloading your selected information", "Reloading your selected information"],
    ["Your Trip", "Your Trip"],
    ["Your Selection", "Your Selection"],
    ["Your Car Equipment", "Car Equipment"],
    ["Add a product first", "Add a product first"],
    ["Book Now", "Book Now"],
    ["Your pending bookings", "Your pending bookings"],
    ["Your confirmed bookings", "Your confirmed bookings"],
    ["Show my Bookings", "Show my Bookings"],
    ["this link has expired", "We are sorry, this link has expired"],
    ["Page not found", "Page not found"],
    ["Free", "Free"],
    ["Equipment Shop", "Equipment Shop"],
    ["Pick Car Equipment For...", "Pick Car Equipment For..."],
    ["Select your interest", "Select your interest(s) and get matching recommendations."],
    ["View Locations", "View Locations"],
    ["Discover", "Discover"],
    ["My Experiences", "My Experiences"],
    ["My Bookings", "My Bookings"],
    ["Payment Information", "Payment Information"],
    ["error payment submission.", "An error occurred during your payment submission."],
    ["Please go back payment", "Please go back to the home page and try again. If a payment was debited from your account, please contact us immediately"],
    ["Go back", "Go back"],
    ["Checkout", "Checkout"],
    ["Card Number", "Card Number"],
    ["Cardholder Name", "Cardholder Name"],
    ["John Doe", "John Doe"],
    ["Expiration Date", "Expiration Date"],
    ["CVV", "CVV"],
    ["The payment for this item didn't go through.", "The payment for this item didn't go through."],
    ["mock card number", "mock card number"],
    ["mock expiry", "mock expiry"],
    ["mock cvv", "mock cvv"],
    ["Final payment details will be listed", "Final payment details will be listed during the  payment process."],
    ["First name", "First name"],
    ["Last name", "Last name"],
    ["Street and Number", "Street and Number"],
    ["Postal code", "Postal code"],
    ["City", "City"],
    ["Country", "Country"],
    ["Email Address", "Email Address"],
    ["I confirm that the above information is correct", "I confirm that the above information is correct"],
    ["Please use the following card", "Please use the following card data to proceed with the <span>DEMO</span> payment:"],
    ["Imprint", "Imprint"],
    ["Privacy Policy", "Privacy Policy"],
    ["Terms of Use", "Terms of Use"],
    ["booked the following equipment", "You have booked the following equipment for your activity:"],
    ["call", "call"],
    ["email", "email"],
    ["Your booking is confirmed and invoice", "Your booking is confirmed and we will shortly send you a confirmation via email. You will receive the invoice from the service provider when picking up your equipment."],
    ["If you wish to cancel", "If you wish to cancel the booking or have any further questions, please call the number above."],
    ["Hello", "Hello"],
    ["ORDER ID", "ORDER ID"],
    ["Clear all", "Clear all"],
    ["Available Offers", "Available Offers"],
    ["to", "to"],
    ["Start", "Start"],
    ["End", "End"],
    ["Create your individual trip", "Create your individual trip with the offers from the list"],
    ["Add products and options", "Add products and options from the list"],
]);
